import { AxiosResponse } from 'axios';
import { Api } from '../../../lib/axios';

export const GeocodeService = {
  findAddress: (latitude: number, longitude: number): Promise<AxiosResponse> =>
    Api.get('geocode', { params: { latitude, longitude } }),
};
